<div fxLayout="column" fxLayoutGap="20px">
  <app-page-header title="Tipos de Recursos" variant="responsive-md">
    <button mat-raised-button color="primary" routerLink="/tipo-recurso/incluir">
      <mat-icon>add</mat-icon> Adicionar
    </button>
  </app-page-header>

  <app-search-input #searchInput></app-search-input>

  <div>
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>#</th>
        <td mat-cell *matCellDef="let row">{{ row.id }}</td>
      </ng-container>
      <ng-container matColumnDef="tipoAndamento">
        <th mat-header-cell *matHeaderCellDef>Andamento</th>
        <td mat-cell *matCellDef="let row">{{ row.tipoAndamento }}</td>
      </ng-container>
      <ng-container matColumnDef="tipoRecurso">
        <th mat-header-cell *matHeaderCellDef>Recurso</th>
        <td mat-cell *matCellDef="let row">{{ row.tipoRecurso }}</td>
      </ng-container>
      <ng-container matColumnDef="tipoConcurso">
        <th mat-header-cell *matHeaderCellDef>Tipo Concurso</th>
        <td mat-cell *matCellDef="let row">{{ row.tipoConcurso }}</td>
      </ng-container>
      <ng-container matColumnDef="prazo">
        <th mat-header-cell *matHeaderCellDef>Prazo</th>
        <td mat-cell *matCellDef="let row">{{ row.prazo }}</td>
      </ng-container>
      <ng-container matColumnDef="categoria">
        <th mat-header-cell *matHeaderCellDef>Responsável</th>
        <td mat-cell *matCellDef="let row">{{ row.categoria }}</td>
      </ng-container>
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row; let i = index">
          <button mat-icon-button color="basic" routerLink="/tipo-recurso/editar/{{ row.id }}" title="Editar">
            <mat-icon>edit</mat-icon>
          </button>
        </td>
      </ng-container>
      <ng-container matColumnDef="actionExcluir">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row; let i = index">
          <button mat-icon-button color="warn" (click)="excluirTipoRecurso(row)" title="Excluir">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="colunasGrid"></tr>
      <tr mat-row *matRowDef="let row; columns: colunasGrid"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="8">
          <app-table-no-data [searchValue]="searchInput.value"></app-table-no-data>
        </td>
      </tr>
    </table>
    <app-default-paginator #paginator [length]="totalElements" [pageSize]="20"></app-default-paginator>
  </div>
</div>
